const getters = {
  isLoggedIn: (state) => state.user.isLoggedIn,
  iERPToken: (state) => state.user.iERPToken,
};
export default getters;
